import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import DeletedRecordsTable from "@/components/deleted-records/deleted-records-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

const trashSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  tableName: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/settings/_layout/trash")({
  validateSearch: trashSearchSchema,
  component: TrashPage,
});

function TrashPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "deleted_records", actions: ["read", "update"] }]}
    >
      <div className="overflow-x-auto">
        <DeletedRecordsTable
          currentPage={searchParams.page}
          pageSize={10}
          basePath="/settings/trash"
          searchParams={searchParams}
        />
      </div>
    </RouteGuardPermissions>
  );
}
